import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import tzlookup from "tz-lookup";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const BACKEND_DATE_FORMAT = "YYYY-MM-DD";

export function getSiteTimezone(siteConfig, currentSite) {
  const configuredTimezone = siteConfig?.timezone;
  if (configuredTimezone) return configuredTimezone;

  const lat = Number(currentSite?.lat);
  const long = Number(currentSite?.long);
  if (Number.isFinite(lat) && Number.isFinite(long)) {
    return tzlookup(lat, long);
  }

  return dayjs.tz.guess();
}

export function siteDayjs(value, siteTimezone) {
  if (!value) return dayjs().tz(siteTimezone);
  return dayjs.tz(value, BACKEND_DATE_FORMAT, siteTimezone);
}
